import script from "./OtherExpenses.vue?vue&type=script&setup=true&lang=js"
export * from "./OtherExpenses.vue?vue&type=script&setup=true&lang=js"

import "./OtherExpenses.vue?vue&type=style&index=0&id=e10c825e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e10c825e"]])

export default __exports__